import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import { Container, ContainerInterno } from '../styles';
import RModal from '../../../components/Rsuite/Modal';
import { toastSuccess, toastError } from '../../../toasts';
import { useAuth } from '../../../hooks/auth';
import { CustomButton } from '../../../components/CustomButton';
import { CustomInput } from '../../../components/CustomInput';
import { useCustomTheme } from '../../../hooks/useCustomTheme';

const EditarCadastrarMensagem = ({
  open,
  close,
  objMensagem,
  setMensagens,
}) => {
  const { id_empresa } = useAuth();
  const [titulo, setTitulo] = useState('');
  const [mensagem, setMensagem] = useState('');
  const { theme } = useCustomTheme();

  const cadastrar = async () => {
    await api
      .post('mensagem-cartao-visita/criar', {
        IdEmpresa: id_empresa,
        Titulo: titulo,
        Mensagem: mensagem,
      })
      .then((res) => {
        setMensagens((state) => [...state, res.data]);
        toastSuccess('Mensagem cadastrada');
        close();
      })
      .catch((error) => toastError(error));
  };

  const alterar = async () => {
    await api
      .patch(`mensagem-cartao-visita/alterar/${objMensagem.Id}`, {
        IdEmpresa: id_empresa,
        Titulo: titulo,
        Mensagem: mensagem,
        Ativo: objMensagem.Ativo,
      })
      .then((res) => {
        setMensagens((state) =>
          state.map((e) => {
            if (e.Id !== res.data.Id) {
              return e;
            }
            e = res.data;
            return e;
          }),
        );
        toastSuccess('Mensagem alterada');
        close();
      });
  };

  const salvar = () => {
    if (objMensagem) {
      alterar();
    } else {
      cadastrar();
    }
  };

  useEffect(() => {
    if (objMensagem) {
      setTitulo(objMensagem.Titulo);
      setMensagem(objMensagem.Mensagem);
    }
  }, []);

  return (
    <RModal
      open={open}
      onClose={close}
      title={objMensagem ? `Editar Mensagem` : `Cadastrar Mensagem`}
      footer={
        <>
          <CustomButton onClick={salvar} appearance="primary">
            Salvar
          </CustomButton>
          <CustomButton onClick={close} appearance="ghost">
            Fechar
          </CustomButton>
        </>
      }
    >
      <form>
        <Container>
          <ContainerInterno>
            <label>
              <b style={{ color: theme.colors.textSecondary }}>Título</b>
            </label>
            <CustomInput type="text" value={titulo} onChange={setTitulo} />
          </ContainerInterno>
          <ContainerInterno>
            <label>
              <b style={{ color: theme.colors.textSecondary }}>Mensagem</b>
            </label>
            <CustomInput type="text" value={mensagem} onChange={setMensagem} />
          </ContainerInterno>
        </Container>
      </form>
    </RModal>
  );
};

export default EditarCadastrarMensagem;
